var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 180,
    viewBox: "0 0 190 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.369 97.7906C114.116 99.107 106.971 99.9784 103.935 100.139H117.628C117.267 99.3287 116.846 98.5441 116.369 97.7906Z",
    fill: "#F2617A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.612 103.101H73.7191L57.2119 135.6C57.9952 136.256 58.8274 136.858 59.7022 137.401L57.2299 142.337C60.7818 143.262 64.5237 143.314 68.103 142.49L69.0134 140.476C69.9212 140.56 70.8333 140.596 71.7454 140.584L78.2104 129.364L76.2669 138.678C77.1404 139.086 78.0388 139.445 78.9574 139.752L78.2406 142.488C81.4769 143.365 84.9077 143.365 88.1449 142.488L88.449 141.199C89.3236 141.195 90.1978 141.16 91.0695 141.093L98.1927 113.767L100.346 114.074L115.328 112.934C118.408 110.545 119.75 107.577 118.612 103.101Z",
    fill: "#F2617A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7156 75.9969C61.6615 76.621 61.4168 77.2167 61.0116 77.7111C60.6063 78.2056 60.0579 78.5774 59.4335 78.7811C58.809 78.9849 58.1355 79.0117 57.4952 78.8584C56.8549 78.7051 56.2755 78.3783 55.8279 77.9179C55.3803 77.4575 55.0837 76.8834 54.9745 76.2658C54.8653 75.6482 54.9482 75.0138 55.213 74.4401C55.4778 73.8664 55.913 73.3783 56.4656 73.0353C57.0181 72.6924 57.6641 72.5095 58.3244 72.5089C59.2618 72.5452 60.1456 72.9331 60.7815 73.5871C61.4175 74.2412 61.7534 75.108 61.7156 75.9969Z",
    fill: "#F2617A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3703 71.0458C59.8264 71.4264 59.1615 71.6189 58.4863 71.5903C58.5524 70.9527 58.8508 70.3572 59.3296 69.9059C59.8734 69.5252 60.5384 69.333 61.2136 69.3614C61.1475 69.9987 60.8493 70.5943 60.3703 71.0458Z",
    fill: "#F2617A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8253 67.6125C99.7951 68.0596 99.6997 68.5004 99.542 68.9227L101.264 67.3914C100.796 67.5217 100.313 67.596 99.8253 67.6125Z",
    fill: "#634F7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.68 82.0372V89.966C107.146 89.8979 107.613 89.8299 108.079 89.7448C107.83 87.1444 107.362 84.567 106.68 82.0372Z",
    fill: "#634F7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2196 93.7942L94.0306 93.0286C93.7768 92.822 93.5314 92.6063 93.2949 92.382C93.871 90.017 95.4121 90.9018 96.2196 93.7942Z",
    fill: "#634F7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4966 64.5293V86.0356C79.4961 86.8206 79.1671 87.5734 78.5817 88.1285C77.9963 88.6836 77.2025 88.9956 76.3746 88.9961H75.1904C76.0183 88.9956 76.8121 88.6836 77.3975 88.1285C77.9829 87.5734 78.3119 86.8206 78.3124 86.0356V64.5293C78.3119 63.7442 77.9829 62.9915 77.3975 62.4364C76.8121 61.8813 76.0183 61.5692 75.1904 61.5687H76.3746C77.2025 61.5692 77.9963 61.8813 78.5817 62.4364C79.1671 62.9915 79.4961 63.7442 79.4966 64.5293Z",
    fill: "#634F7D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1748 99.3919H65.8423C65.4683 99.3951 65.1065 99.2662 64.8272 99.0303C64.5479 98.7944 64.3712 98.4685 64.3313 98.1159L63.3483 89.0149H62.1641L63.4739 100.347H69.1617C69.1644 100.222 69.1409 100.098 69.0926 99.9825C69.0442 99.8667 68.9719 99.7613 68.88 99.6724C68.7881 99.5835 68.6784 99.5128 68.5573 99.4647C68.4362 99.4165 68.3061 99.3918 68.1748 99.3919Z",
    fill: "#634F7D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.026 61.4667C108.237 61.2252 108.351 60.9201 108.347 60.6061C108.342 60.2921 108.22 59.9899 108.001 59.754C107.783 59.5181 107.483 59.3638 107.155 59.3191C106.827 59.2744 106.493 59.3421 106.213 59.51C106.366 59.2512 106.422 58.9513 106.372 58.6587C106.322 58.3662 106.169 58.0982 105.939 57.8981C105.709 57.6979 105.414 57.5768 105.103 57.5544C104.791 57.532 104.481 57.6095 104.222 57.7745C105.059 56.3462 102.66 55.1256 101.767 56.4984C101.214 58.0484 100.524 59.5511 99.7031 60.9903C102 57.9456 103.543 61.1774 103.399 63.0831C103.417 63.4574 103.615 63.5595 104.261 63.1171C105.588 62.1983 106.539 64.3421 104.063 65.397C103.3 66.7889 103.078 68.3911 103.435 69.9229C103.417 69.6847 103.13 64.9376 108.782 63.9508C109.075 63.8921 109.337 63.7403 109.526 63.5205C109.715 63.3008 109.819 63.0263 109.821 62.7428C109.823 62.5357 109.774 62.331 109.677 62.1454C109.58 61.9597 109.439 61.7984 109.264 61.6744C109.089 61.5501 108.886 61.4664 108.671 61.4303C108.456 61.3942 108.235 61.4067 108.026 61.4667Z",
    fill: "#634F7D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.355 75.4525C102.355 75.6152 102.287 75.7712 102.166 75.8863C102.044 76.0013 101.88 76.0659 101.708 76.0659C101.537 76.0659 101.372 76.0013 101.251 75.8863C101.13 75.7712 101.062 75.6152 101.062 75.4525C101.062 75.2898 101.13 75.1338 101.251 75.0188C101.372 74.9037 101.537 74.8391 101.708 74.8391C101.88 74.8391 102.044 74.9037 102.166 75.0188C102.287 75.1338 102.355 75.2898 102.355 75.4525Z",
    fill: "#634F7D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1473 81.1185C96.1473 81.2812 96.0791 81.4373 95.9578 81.5523C95.8365 81.6673 95.672 81.732 95.5004 81.732C95.3288 81.732 95.1643 81.6673 95.043 81.5523C94.9217 81.4373 94.8535 81.2812 94.8535 81.1185C94.8535 80.9559 94.9217 80.7998 95.043 80.6848C95.1643 80.5698 95.3288 80.5051 95.5004 80.5051C95.672 80.5051 95.8365 80.5698 95.9578 80.6848C96.0791 80.7998 96.1473 80.9559 96.1473 81.1185Z",
    fill: "#634F7D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.974 87.5328C100.974 87.6955 100.906 87.8516 100.785 87.9666C100.664 88.0816 100.499 88.1463 100.328 88.1463C100.156 88.1463 99.9914 88.0816 99.8701 87.9666C99.7488 87.8516 99.6807 87.6955 99.6807 87.5328C99.6807 87.3702 99.7488 87.2141 99.8701 87.0991C99.9914 86.9841 100.156 86.9194 100.328 86.9194C100.499 86.9194 100.664 86.9841 100.785 87.0991C100.906 87.2141 100.974 87.3702 100.974 87.5328Z",
    fill: "#634F7D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.46 89.4554H130.001C129.772 89.4554 129.553 89.5415 129.392 89.6946C129.23 89.8478 129.14 90.0555 129.14 90.2721V99.3239C129.14 99.5405 129.23 99.7482 129.392 99.9013C129.553 100.055 129.772 100.141 130.001 100.141H136.46C136.688 100.138 136.905 100.051 137.066 99.8983C137.227 99.7457 137.319 99.5396 137.321 99.3239V90.2686C137.32 90.0528 137.228 89.8464 137.067 89.6942C136.906 89.5419 136.688 89.4561 136.46 89.4554Z",
    fill: "#634F7D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.517 46.389L126.779 48.652C126.623 48.6923 126.481 48.7708 126.367 48.8794C126.253 48.9881 126.171 49.1231 126.129 49.2712C126.087 49.4192 126.087 49.5751 126.129 49.7232C126.17 49.8713 126.252 50.0064 126.366 50.1152L134.225 57.4995C134.31 57.5809 134.412 57.6454 134.524 57.6895C134.636 57.7335 134.756 57.7562 134.877 57.7562C134.998 57.7562 135.118 57.7335 135.23 57.6895C135.342 57.6454 135.443 57.5809 135.529 57.4995C135.643 57.391 135.725 57.2561 135.768 57.1082L138.1 48.669L135.517 46.389Z",
    fill: "#634F7D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.57 42.9271C141.254 42.632 140.826 42.4681 140.382 42.4715C139.938 42.4748 139.514 42.6452 139.202 42.945L135.56 46.4321L138.015 48.5929L141.585 45.173C141.893 44.8712 142.064 44.467 142.061 44.0471C142.058 43.6273 141.882 43.2252 141.57 42.9271Z",
    fill: "#634F7D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5144 31.5238C64.514 31.6669 64.4839 31.8086 64.4258 31.9406C64.3677 32.0727 64.2827 32.1927 64.1757 32.2936C64.0688 32.3946 63.9419 32.4746 63.8023 32.529C63.6627 32.5834 63.5132 32.6113 63.3623 32.6109C63.2113 32.6106 63.062 32.582 62.9227 32.5269C62.7834 32.4718 62.6569 32.3913 62.5504 32.2898C62.444 32.1884 62.3596 32.068 62.3022 31.9357C62.2448 31.8033 62.2155 31.6615 62.2158 31.5184C62.2166 31.2294 62.3384 30.9525 62.5544 30.7486C62.7705 30.5447 63.0631 30.4306 63.3679 30.4313C63.6727 30.432 63.9648 30.5475 64.1798 30.7524C64.3948 30.9573 64.5151 31.2347 64.5144 31.5238Z",
    fill: "#634F7D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1455 142.49C84.9083 143.367 81.4784 143.367 78.2412 142.49C75.2089 143.324 69.252 147.339 69.252 147.339H89.2938C89.1041 145.687 88.7189 144.06 88.1455 142.49Z",
    fill: "#634F7D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1035 142.49C64.5245 143.315 60.782 143.262 57.2303 142.337C53.9785 143.348 51.0182 145.06 48.582 147.339H69.2339C68.9823 145.699 68.6045 144.078 68.1035 142.49Z",
    fill: "#634F7D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.899 113.803L100.346 114.076L98.1934 113.769L98.6419 112.051L103.899 113.803Z",
    fill: "#634F7D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.034 100.141H26.5483C26.1343 100.141 25.7373 100.297 25.4445 100.574C25.1518 100.852 24.9873 101.228 24.9873 101.621C24.9873 102.014 25.1518 102.39 25.4445 102.668C25.7373 102.945 26.1343 103.101 26.5483 103.101H45.6647L36.8653 149.296C36.8502 149.38 36.8445 149.466 36.8473 149.551H40.0052L48.8481 103.101H143.767L152.613 149.568H155.771C155.753 149.483 155.753 149.398 155.735 149.299L146.936 103.105H166.034C166.438 103.092 166.822 102.93 167.103 102.654C167.384 102.377 167.541 102.008 167.541 101.625C167.541 101.241 167.384 100.872 167.103 100.596C166.822 100.319 166.438 100.158 166.034 100.144V100.141Z",
    fill: "#634F7D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5144 31.5238C64.514 31.6669 64.4839 31.8086 64.4258 31.9406C64.3677 32.0727 64.2827 32.1927 64.1757 32.2936C64.0688 32.3946 63.9419 32.4746 63.8023 32.529C63.6627 32.5834 63.5132 32.6113 63.3623 32.6109C63.2113 32.6106 63.062 32.582 62.9227 32.5269C62.7834 32.4718 62.6569 32.3913 62.5504 32.2898C62.444 32.1884 62.3596 32.068 62.3022 31.9357C62.2448 31.8033 62.2155 31.6615 62.2158 31.5184C62.2166 31.2294 62.3384 30.9525 62.5544 30.7486C62.7705 30.5447 63.0631 30.4306 63.3679 30.4313C63.6727 30.432 63.9648 30.5475 64.1798 30.7524C64.3948 30.9573 64.5151 31.2347 64.5144 31.5238Z",
    stroke: "black",
    strokeWidth: 0.769171
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.57 42.9271C141.254 42.632 140.826 42.4681 140.382 42.4715C139.938 42.4748 139.514 42.6452 139.202 42.945L135.56 46.4321L138.015 48.5929L141.585 45.173C141.893 44.8712 142.064 44.467 142.061 44.0471C142.058 43.6273 141.882 43.2252 141.57 42.9271Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M166.034 100.141H26.5483C26.1343 100.141 25.7373 100.297 25.4445 100.574C25.1518 100.852 24.9873 101.228 24.9873 101.621C24.9873 102.014 25.1518 102.39 25.4445 102.668C25.7373 102.945 26.1343 103.101 26.5483 103.101H45.6647L36.8653 149.296C36.8502 149.38 36.8445 149.466 36.8473 149.551H40.0052L48.8481 103.101H143.767L152.613 149.568H155.771C155.753 149.483 155.753 149.398 155.735 149.299L146.936 103.105H166.034C166.438 103.092 166.822 102.93 167.103 102.654C167.384 102.377 167.541 102.008 167.541 101.625C167.541 101.241 167.384 100.872 167.103 100.596C166.822 100.319 166.438 100.158 166.034 100.144V100.141Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1462 97.8267C91.4014 98.7832 90.3775 99.5121 89.201 99.9233C88.0244 100.334 86.7467 100.41 85.5254 100.141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5637 94.9682C51.5637 94.9682 42.8389 94.2035 41.6367 100.141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6642 96.2953C54.3951 96.1592 54.1779 96.0267 53.9645 95.904C52.9502 95.3228 52.5829 94.9341 51.6858 94.3727C50.823 93.8303 50.0231 93.2029 49.2994 92.5011C47.3068 90.5623 47.9716 90.2211 50.2145 91.4972C50.228 91.4991 50.2406 91.5051 50.2504 91.5142C51.7396 92.3696 53.2927 93.1206 54.8975 93.761",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9645 95.904C52.0042 95.0818 49.9845 94.3935 47.9207 93.8444C46.1812 93.3805 46.4853 93.0089 46.7724 92.9596C47.8323 92.8832 48.8979 92.9232 49.9482 93.0787",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3411 99.3919C53.978 99.3463 53.6127 99.3179 53.2466 99.3068C50.1445 99.1993 51.238 98.5447 52.3136 98.2519C52.8708 98.1006 53.7849 97.9286 54.5206 97.6904",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.446 115.539L126.56 149.568",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M126.991 90.8337L118.594 90.2552",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 141.201L88.1445 142.49",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2227 142.49L78.9566 139.754",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0166 140.465L68.1025 142.49",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2119 142.354L59.7022 137.401",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2227 129.32L71.7454 140.584C66.405 140.758 61.1995 138.973 57.2119 135.6L73.7191 103.101",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9199 141.133L92.5407 111.37C92.6371 110.935 92.8235 110.523 93.0892 110.157C93.3548 109.791 93.6945 109.479 94.0883 109.238C94.4822 108.998 94.9225 108.834 95.3837 108.756C95.8449 108.678 96.3179 108.687 96.7752 108.784C102.346 109.965 112.819 111.05 113.873 103.141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5859 92.5575L82.9234 89.4233C86.2786 84.5876 90.2638 73.3867 96.0394 71.8303C96.9863 71.6013 97.8489 71.1305 98.5334 70.4691",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.825 67.6124C100.301 67.5963 100.773 67.5303 101.233 67.4154L99.5332 68.9225",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.719 70.6034C103.996 71.087 104.458 71.4523 105.011 71.6243C107.881 72.6401 110.54 74.1252 112.869 76.0122C115.527 78.3244 117.874 86.7967 118.898 92.3802C119.146 93.6927 118.862 95.0455 118.103 96.1684C117.345 97.2912 116.168 98.1015 114.807 98.4373C111.258 99.3722 107.612 99.9426 103.934 100.139",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M110.124 89.3534C104.916 90.3059 99.6365 90.8635 94.335 91.0208",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.061 89.7313C107.827 87.1289 107.359 84.5502 106.661 82.0237V89.9695",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6807 92.0758C67.3154 94.4522 67.8956 97.3441 67.2955 100.124",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8577 93.3348C86.4761 93.9133 82.9414 94.867 81.0395 95.4446C80.1424 95.7133 81.7393 96.6867 87.1579 95.2064",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1267 94.6619C86.8169 95.4445 84.9159 96.3454 83.1925 97.214C82.385 97.6215 83.1207 98.5071 87.8934 96.6355",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5035 95.9038C87.748 96.7886 87.0935 97.6465 85.83 98.9324C85.2417 99.5315 86.322 99.895 90.3157 97.2309C91.0522 96.7393 91.4489 97.2784 92.4149 98.0476C93.6926 99.064 94.5501 100.243 95.4831 100.123",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8362 91.9396C89.4007 88.8054 90.3338 88.6263 90.8362 89.4215C91.6877 90.725 92.7189 91.9148 93.9024 92.9596",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2939 92.3821C93.7416 90.5373 94.7794 90.6699 95.5972 92.1904C96.5415 93.9492 97.4028 100.141 95.4291 100.141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1524 93.7709C94.0418 93.024 90.6554 91.7184 89.7413 91.7184C89.4004 91.7184 85.5068 92.793 83.6229 93.2837C82.3848 93.6079 81.7937 94.1497 83.8023 94.0834C84.6456 94.0556 85.5786 93.9473 86.4219 93.8452",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2168 80.5078C91.4395 84.1109 91.4884 87.8306 92.3602 91.4141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4735 100.124H54.251L55.3993 89.0132H62.1816L63.4735 100.124Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7156 75.9969C61.6615 76.621 61.4168 77.2167 61.0116 77.7111C60.6063 78.2056 60.0579 78.5774 59.4335 78.7811C58.809 78.9849 58.1355 79.0117 57.4952 78.8584C56.8549 78.7051 56.2755 78.3783 55.8279 77.9179C55.3803 77.4575 55.0837 76.8834 54.9745 76.2658C54.8653 75.6482 54.9482 75.0138 55.213 74.4401C55.4778 73.8664 55.913 73.3783 56.4656 73.0353C57.0181 72.6924 57.6641 72.5095 58.3244 72.5089C59.2618 72.5452 60.1456 72.9331 60.7815 73.5871C61.4175 74.2412 61.7534 75.108 61.7156 75.9969Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3693 71.0458C59.8254 71.4264 59.1606 71.6189 58.4854 71.5903C58.5515 70.9527 58.8499 70.3572 59.3287 69.9059C59.8724 69.5252 60.5374 69.333 61.2126 69.3614C61.1465 69.9987 60.8483 70.5943 60.3693 71.0458Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7002 61.0073C100.519 59.5673 101.209 58.0647 101.764 56.5154C101.891 56.3379 102.062 56.1918 102.261 56.0892C102.461 55.9867 102.683 55.9307 102.909 55.9259C103.136 55.9211 103.361 55.9676 103.565 56.0615C103.769 56.1555 103.946 56.2942 104.082 56.4662C104.263 56.6963 104.362 56.9766 104.365 57.2641C104.363 57.4484 104.314 57.6294 104.222 57.7915C104.481 57.6273 104.791 57.5505 105.102 57.5733C105.413 57.5961 105.707 57.7173 105.936 57.9174C106.166 58.1175 106.318 58.3849 106.368 58.6768C106.419 58.9687 106.364 59.2681 106.213 59.527C106.493 59.3591 106.827 59.2914 107.155 59.3361C107.483 59.3809 107.783 59.5351 108.001 59.771C108.22 60.0069 108.342 60.3091 108.347 60.6231C108.351 60.9371 108.237 61.2422 108.026 61.4837C108.198 61.4314 108.38 61.4123 108.56 61.4277C108.741 61.4431 108.916 61.4925 109.076 61.5731C109.236 61.6537 109.378 61.7639 109.492 61.8971C109.606 62.0303 109.691 62.1838 109.742 62.3487C109.818 62.5975 109.812 62.862 109.727 63.1079C109.642 63.3538 109.481 63.5698 109.265 63.7278C109.121 63.8321 108.956 63.908 108.781 63.9508C107.253 64.1077 105.846 64.8146 104.852 65.9257C103.857 67.0368 103.35 68.4675 103.434 69.9229",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.719 70.6034L103.379 73.1556L100.633 71.0968L97.5293 72.5771L98.5341 70.4673",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100.633 71.0968C98.3726 76.5074 97.5652 83.2962 97.5293 90.8506",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M137.325 92.365C138.006 92.365 138.659 92.6211 139.139 93.0778C139.378 93.3035 139.567 93.5716 139.696 93.8668C139.826 94.162 139.892 94.4785 139.892 94.7981C139.892 95.1177 139.826 95.4341 139.696 95.7293C139.567 96.0245 139.378 96.2926 139.139 96.5183C138.659 96.975 138.006 97.2311 137.325 97.2311",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M160.848 69.7867C160.849 70.0082 160.797 70.227 160.698 70.4273C160.598 70.6276 160.452 70.8044 160.272 70.9449C160.091 71.0854 159.88 71.1862 159.654 71.2399C159.427 71.2935 159.191 71.2988 158.962 71.2553C158.732 71.2125 158.516 71.1219 158.328 70.9901C158.14 70.8583 157.986 70.6885 157.876 70.4932C157.766 70.2978 157.703 70.0816 157.691 69.8603C157.68 69.639 157.721 69.4181 157.81 69.2136C157.931 68.9403 158.133 68.7068 158.393 68.5425C158.653 68.3782 158.958 68.2905 159.27 68.2904C159.582 68.2903 159.888 68.3778 160.147 68.542C160.407 68.7061 160.61 68.9395 160.73 69.2127C160.81 69.3945 160.849 69.5897 160.848 69.7867Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M148.163 95.819L159.27 71.2841",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M159.269 68.2895L143.085 51.0708",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M141.147 49.8968L138.401 48.2294",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.942 55.3585C131.651 55.5744 131.307 55.7162 130.942 55.7705C130.577 55.8248 130.203 55.7898 129.856 55.6688C129.509 55.5479 129.201 55.3449 128.96 55.0792C128.719 54.8134 128.554 54.4938 128.48 54.1505C128.417 53.8608 128.421 53.5616 128.492 53.2737C128.564 52.9858 128.7 52.716 128.892 52.483",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M143.354 50.3732C143.354 50.5369 143.317 50.6986 143.243 50.8466C143.169 50.9947 143.062 51.1253 142.928 51.2292C142.795 51.333 142.639 51.4073 142.471 51.4469C142.304 51.4864 142.129 51.4901 141.96 51.4576C141.674 51.4058 141.42 51.2547 141.246 51.0338C141.071 50.8129 140.991 50.5383 141.019 50.2639C141.048 49.9895 141.183 49.7351 141.4 49.5507C141.616 49.3663 141.897 49.2652 142.188 49.2672C142.496 49.2714 142.79 49.3893 143.008 49.5958C143.225 49.8023 143.35 50.0812 143.354 50.3732Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M149.311 96.9248C149.311 97.0884 149.273 97.2502 149.2 97.3982C149.126 97.5463 149.019 97.6769 148.885 97.7807C148.752 97.8846 148.596 97.9589 148.428 97.9984C148.261 98.0379 148.086 98.0416 147.917 98.0092C147.691 97.9669 147.483 97.8615 147.32 97.7065C147.198 97.5908 147.105 97.4509 147.047 97.297C146.989 97.1431 146.968 96.9789 146.985 96.8163C147.002 96.6537 147.057 96.4966 147.145 96.3564C147.233 96.2161 147.354 96.0962 147.497 96.0051C147.721 95.8622 147.99 95.7978 148.259 95.8228C148.528 95.8478 148.779 95.9607 148.97 96.1421C149.078 96.2449 149.164 96.3669 149.222 96.5012C149.281 96.6355 149.311 96.7795 149.311 96.9248Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M100.345 117.87L98.1924 149.568",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1967 46.562H54.5029V36.4214H65.1967V46.562Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8496 38.7353L62.9716 32.491",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0779 119.63H20.9141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9873 123.501V115.76",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M161.171 114.722C161.203 115.054 161.157 115.389 161.036 115.702C160.915 116.015 160.723 116.299 160.472 116.533C160.222 116.767 159.919 116.946 159.587 117.055C159.255 117.165 158.902 117.204 158.552 117.168C158.084 117.121 157.642 116.943 157.281 116.658C156.919 116.373 156.655 115.992 156.522 115.565C156.422 115.245 156.399 114.908 156.453 114.579C156.508 114.249 156.638 113.936 156.836 113.66C157.033 113.384 157.293 113.153 157.595 112.984C157.898 112.814 158.237 112.711 158.587 112.68C159.056 112.634 159.53 112.724 159.945 112.937C160.36 113.149 160.698 113.476 160.915 113.874C161.058 114.137 161.145 114.426 161.171 114.722Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19629 149.568H184.622",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M69.251 147.339H89.2928",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5635 147.339H69.2154",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2507 147.312C69.0606 145.668 68.6757 144.051 68.1033 142.489C64.5243 143.314 60.7818 143.261 57.2301 142.336C52.9733 143.706 49.2232 146.211 46.4287 149.551C54.7182 149.551 60.2265 149.568 66.4706 149.551",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1443 142.49C84.9071 143.366 81.4773 143.366 78.24 142.49C73.7714 143.718 68.0534 148.049 66.4697 149.551C75.9434 149.551 81.9003 149.466 89.3465 149.466C89.4122 147.089 89.0043 144.723 88.1443 142.49Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1924 113.769L98.6409 112.051L103.898 113.803",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1924 113.769L100.345 114.075L119.721 112.575",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M122.218 112.748L116.117 112.323",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8604 139.955L81.0398 115.811",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9824 90.7485C100.597 93.0115 101.01 96.1421 100.185 100.141",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2061 117.529L100.346 117.87L119.988 116.321C120.401 116.291 120.793 116.138 121.108 115.885C121.424 115.631 121.647 115.29 121.747 114.909L130.234 75.895C130.374 75.2637 130.292 74.6061 130.001 74.0232C129.709 73.4403 129.223 72.9643 128.619 72.6685C128.218 72.4713 127.778 72.3589 127.327 72.339L104.329 71.2841",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7595 102.591C87.9219 102.927 86.2317 103.775 84.9052 105.026C83.5787 106.278 82.6763 107.877 82.3133 109.618L76.2695 138.679C80.8796 140.747 85.9978 141.583 91.0721 141.096C91.0721 141.012 96.5673 119.998 98.1953 113.771",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1903 61.5687C76.0182 61.5692 76.812 61.8813 77.3973 62.4364C77.9827 62.9915 78.3118 63.7442 78.3123 64.5293V86.0526C78.3123 86.8379 77.9834 87.5911 77.398 88.1466C76.8126 88.7021 76.0185 89.0144 75.1903 89.0149H44.1676C43.339 89.0144 42.5443 88.7026 41.9576 88.1478C41.3708 87.5929 41.0399 86.8402 41.0371 86.0544V64.5293C41.0364 64.1407 41.1164 63.7559 41.2727 63.3967C41.429 63.0376 41.6584 62.7112 41.9479 62.4362C42.2373 62.1612 42.5811 61.943 42.9596 61.7942C43.338 61.6453 43.7437 61.5687 44.1535 61.5687H75.1903Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4966 64.5293V86.0356C79.4961 86.8206 79.1671 87.5734 78.5817 88.1285C77.9963 88.6836 77.2025 88.9956 76.3746 88.9961H75.1904C76.0183 88.9956 76.8121 88.6836 77.3975 88.1285C77.9829 87.5734 78.3119 86.8206 78.3124 86.0356V64.5293C78.3119 63.7442 77.9829 62.9915 77.3975 62.4364C76.8121 61.8813 76.0183 61.5692 75.1904 61.5687H76.3746C77.2025 61.5692 77.9963 61.8813 78.5817 62.4364C79.1671 62.9915 79.4961 63.7442 79.4966 64.5293Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M104.258 63.1349C105.58 62.2108 106.524 64.3465 104.061 65.4149C103.718 65.5635 102.661 68.8348 103.72 70.6088C102.029 71.1362 99.9877 71.4505 98.5344 70.4726C99.302 69.6904 99.7584 68.6791 99.8253 67.6124C95.1602 67.6805 99.61 60.9938 99.6997 60.9938C101.98 57.9697 103.518 61.1514 103.399 63.0463C103.364 63.606 103.777 63.4689 104.258 63.1349Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M115.424 112.88C116.616 112.033 117.567 110.919 118.194 109.637C118.82 108.356 119.101 106.947 119.012 105.537C118.947 104.731 118.823 103.931 118.641 103.142",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.368 97.7908C116.854 98.5419 117.279 99.3272 117.638 100.14",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M137.325 99.3239C137.325 99.5405 137.235 99.7482 137.073 99.9014C136.912 100.055 136.693 100.141 136.464 100.141H130.005C129.776 100.141 129.557 100.055 129.396 99.9014C129.234 99.7482 129.144 99.5405 129.144 99.3239V90.2686C129.144 90.052 129.234 89.8443 129.396 89.6911C129.557 89.538 129.776 89.4519 130.005 89.4519H136.46C136.689 89.4521 136.908 89.5383 137.069 89.6914C137.231 89.8445 137.321 90.0521 137.322 90.2686L137.325 99.3239Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M156.273 98.0139C156.344 98.0157 156.411 98.0408 156.462 98.0838C156.486 98.1043 156.506 98.1294 156.52 98.1574C156.533 98.1854 156.541 98.2158 156.542 98.2467V99.9061C156.541 99.937 156.533 99.9674 156.52 99.9954C156.506 100.023 156.486 100.049 156.462 100.069C156.409 100.113 156.342 100.137 156.273 100.139H140.035C139.965 100.137 139.898 100.113 139.846 100.069C139.822 100.049 139.802 100.023 139.788 99.9954C139.774 99.9674 139.767 99.937 139.766 99.9061V98.2467C139.767 98.2158 139.774 98.1854 139.788 98.1574C139.802 98.1294 139.822 98.1043 139.846 98.0838C139.898 98.0402 139.965 98.0154 140.035 98.0139H156.273Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M100.346 117.87V114.075",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M135.516 46.389L126.778 48.652C126.622 48.6923 126.48 48.7708 126.366 48.8794C126.252 48.9881 126.17 49.1231 126.128 49.2712C126.086 49.4192 126.086 49.5751 126.128 49.7232C126.169 49.8713 126.251 50.0064 126.365 50.1152L134.224 57.4995C134.309 57.5809 134.411 57.6454 134.523 57.6895C134.635 57.7335 134.755 57.7562 134.876 57.7562C134.997 57.7562 135.117 57.7335 135.229 57.6895C135.341 57.6454 135.442 57.5809 135.528 57.4995C135.642 57.391 135.725 57.2561 135.767 57.1082L138.099 48.669L135.516 46.389Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentInnovation);
export default __webpack_public_path__ + "static/media/experiment_innovation.c52da7cd406752089dba37751c896382.svg";
export { ForwardRef as ReactComponent };